import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

/**
 * Hero genérico para páginas internas (sem imagem) — usado em Serviços
 * (tema escuro, alinhado à esquerda) e Sobre (tema claro, centralizado).
 *
 * Props:
 * - theme: "dark" (padrão) | "light"
 * - align: "left" (padrão) | "center"
 * - eyebrow: string (opcional)
 * - title: string | ReactNode (para destacar uma palavra, envolva com
 *   <strong className="page-hero__title-highlight">...</strong>)
 * - text: string (opcional)
 * - primaryButton / secondaryButton: { label, to } para rota interna
 *   (usa <Link>) ou { label, href } para âncora/link externo (usa <a>).
 */
export default function PageHero({
  theme = "dark",
  align = "left",
  eyebrow,
  title,
  text,
  primaryButton,
  secondaryButton,
}) {
  const renderButton = (button, className) => {
    if (!button) return null;
    if (button.to) {
      return (
        <Link to={button.to} className={className}>
          {button.label}
        </Link>
      );
    }
    return (
      <a href={button.href} className={className}>
        {button.label}
      </a>
    );
  };

  return (
    <section
      className={`page-hero page-hero--${theme} page-hero--${align}`}
    >
      {theme !== "white" && (
        <>
          <div className="page-hero__blob page-hero__blob--a" aria-hidden="true" />
          <div className="page-hero__blob page-hero__blob--b" aria-hidden="true" />
        </>
      )}

      <div className="page-hero__container">
        {eyebrow && <span className="page-hero__eyebrow">{eyebrow}</span>}
        <h1 className="page-hero__title">{title}</h1>
        {text && <p className="page-hero__text">{text}</p>}

        {(primaryButton || secondaryButton) && (
          <div className="page-hero__actions">
            {renderButton(primaryButton, "page-hero__button page-hero__button--primary")}
            {renderButton(secondaryButton, "page-hero__button page-hero__button--secondary")}
          </div>
        )}
      </div>
    </section>
  );
}
